import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './redux/store';

import './i18n';

// import LoaderLine from './components/Loaders/LoaderLine/LoaderLine';

import * as Tooltip from '@radix-ui/react-tooltip';

import './index.scss';
// import './index.css'

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <Tooltip.Provider>
                    <App />
                    <div id="overlay-root" />
                </Tooltip.Provider>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>
)
